import React from 'react';
import { Container, makeStyles } from '@material-ui/core';

import { Feedback } from 'domain/types';
import FeedbackItem from './FeedbackItem/FeedbackItem';

interface Props {
  feedbacks: Feedback[];
}

const Feedbacks: React.FC<Props> = ({ feedbacks }): JSX.Element => {
  const classes = useStyles();
  return (
    <Container className={classes.container} component="section">
      {feedbacks.map((feedback) => (
        <FeedbackItem key={feedback.sys.id} feedback={feedback} />
      ))}
    </Container>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    columnGap: theme.spacing(2),
    columnCount: 2,
    paddingBottom: theme.spacing(2),
    fontSize: 0,
    [theme.breakpoints.up('sm')]: {
      columnCount: 3,
      columnGap: theme.spacing(4)
    },
    [theme.breakpoints.up('md')]: {
      columnCount: 4
    }
  }
}));

export default Feedbacks;
